/**
 * @description        widget相关操作
 * @autor              shuxiaokai
 * @create             2020-05-12 10:18
 */

export default {
    state: {
        activeState: "config", // enum类型，widget,config,style
    },
    mutations: {
        //改变组件操作状态
        changeWidgetActiveState(state, payload) {
            state.activeState = payload;
        },
    },
};
